import {
  GuestJourneyRetentionCards,
  GuestJourneyRetentionVisit,
} from '../guest-journey-reports.types';

const BASE_COHORT = 12500;
const CRITICAL = new Set([2, 3, 4]);

/**
 * Conversion-from-previous-visit (integer %) and median days from last visit,
 * visits 1–20. Mirrors the design's retention curve (visit 0 baseline omitted).
 * The BE sends `conversionFromLastVisitPct` as an integer percent; the FE
 * divides by 100 (endpoint `transformResponse` / `toConversionFractions`).
 * Mean days from last visit runs a bit above the median (right-skewed intervals).
 */
const CURVE: { visit: number; conv: number; medianDays: number }[] = [
  { visit: 1, conv: 86, medianDays: 0 },
  { visit: 2, conv: 52, medianDays: 5 },
  { visit: 3, conv: 71, medianDays: 8 },
  { visit: 4, conv: 79, medianDays: 13 },
  { visit: 5, conv: 83, medianDays: 18 },
  { visit: 6, conv: 85, medianDays: 24 },
  { visit: 7, conv: 88, medianDays: 30 },
  { visit: 8, conv: 89, medianDays: 37 },
  { visit: 9, conv: 90, medianDays: 44 },
  { visit: 10, conv: 90, medianDays: 52 },
  { visit: 11, conv: 91, medianDays: 60 },
  { visit: 12, conv: 91, medianDays: 69 },
  { visit: 13, conv: 92, medianDays: 78 },
  { visit: 14, conv: 92, medianDays: 88 },
  { visit: 15, conv: 92, medianDays: 98 },
  { visit: 16, conv: 93, medianDays: 109 },
  { visit: 17, conv: 93, medianDays: 121 },
  { visit: 18, conv: 94, medianDays: 134 },
  { visit: 19, conv: 93, medianDays: 147 },
  { visit: 20, conv: 94, medianDays: 160 },
];

export const retentionConversionTrendsFixture: GuestJourneyRetentionVisit[] =
  (() => {
    let cumulative = 1;
    return CURVE.map(({ visit, conv, medianDays }) => {
      cumulative *= conv / 100;
      return {
        visitNumber: visit,
        // Integer percent on the wire (e.g. 86); the FE divides by 100.
        conversionFromLastVisitPct: conv,
        customerCount: Math.round(BASE_COHORT * cumulative),
        medianDaysFromLastVisit: medianDays,
        meanDaysFromLastVisit: Math.round(medianDays * 1.4),
        critical: CRITICAL.has(visit),
      };
    });
  })();

// Type 1 (up = good) lifetime-value checkpoints. Titles and pre-formatted
// values arrive on the BE cards.
export const retentionCardsFixture: GuestJourneyRetentionCards = {
  totalSpendFirst30Days: {
    title: 'Total Spend — First 30 Days',
    value: '$112.40',
    trend: { text: 'Trending Up', direction: 'UP' },
  },
  totalSpendFirst90Days: {
    title: 'Total Spend — First 90 Days',
    value: '$284.50',
    trend: { text: 'Trending Up', direction: 'UP' },
  },
  totalSpendFirst180Days: {
    title: 'Total Spend — First 180 Days',
    value: '$612.80',
    trend: { text: 'Trending Up', direction: 'UP' },
  },
  totalSpendFirst365Days: {
    title: 'Total Spend — First 365 Days',
    value: '$1,148.20',
    trend: { text: 'Trending Up', direction: 'UP' },
  },
};
